/**
 * B_Config.js
 *
 * @목적 : 환경설정값
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

// [D]

let performance = 1;
// let userLevel = 1;

// [V]

// @DES :: performance {num} (1 -> 상급(default), 2 -> 중급, 3 -> 하급)
export function getPerformance() { return performance; }
export function setPerformance(p) { performance = p; }

// @DES :: userLevel {num} (1 -> 상위(default), 2 -> 하위)
// export function getUserLevel() { return userLevel; }
// export function setUserLevel(ul) { userLevel = ul }

// [F]

// @DES :: isDist()를 통해서 빌드 버전과 테스트 버전을 나눌 수 있습니다. (배포시 isDist()를 true로 설정해 주세요.)
export function isDist() { return true; }
// export function isDist() { return false; }


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/util/B_Config.js